import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../../../../utils/app-settings';
import { BusPassRequest, BusRoute } from '../../apply/models/bus-pass-info';

@Injectable({
  providedIn: 'root'
})
export class BusPassApplicationService {

  constructor(private http: HttpClient) { }


  getBusPassStatus(): Observable<BusPassRequest> {
    return this.http.get<BusPassRequest>(AppSettings.apiUrl + "buspass/status")
  }

  getAllBusRoutes(): Observable<BusRoute[]> {
    return this.http.get<BusRoute[]>(AppSettings.apiUrl + "buspass/get-all-routes")
  }

  apply(pickup_stop_mapping_id: number, drop_stop_mapping_id: number) {
    return this.http.post<BusPassRequest>(AppSettings.apiUrl + "buspass", { pickup_stop_mapping_id, drop_stop_mapping_id });
  }
}
